<template>
  <section class="effect-legislator">
    <!-- label -->
    <SectionLabel text="政黨票你投誰？"/>

    <!-- intro -->
    <div class="effect-legislator__intro">
      <span class="effect-legislator__intro-text">不分區立委的廝殺大戰，就從你手上的政黨票開始：獲得5%以上選票的政黨，可以搶進不分區立委席位，而突破3%的政黨可獲得政黨補助款。</span>
      <br/>
      <br/>
      <span class="effect-legislator__intro-text">你支持的立委，有機會進立法院嗎？</span>
    </div>

    <!-- PartySeatsTable -->
    <PartySeatsTable/>
  </section>
</template>

<script>
import SectionLabel from '@/components/SectionLabel'
import PartySeatsTable from '@/components/PartySeatsTable'

export default {
  name: 'EffectLegislator',
  components: {
    SectionLabel,
    PartySeatsTable
  }
}
</script>

<style lang="scss">
.effect-legislator {
  position: relative;
  width: 100%;
  min-height: 50vh;
  padding-bottom: 60px;
  background-image: linear-gradient(to top, rgb(232, 166, 135), rgb(243, 209, 138));
  overflow: hidden;
  @include rwd($RWD_TABLET) {
    padding-bottom: 80px;
  }

  .section-label {
    margin-top: 55px;
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: 87px;
    }
  }

  &__intro {
    position: relative;
    margin: 35px 13px;
    text-align: center;
    @include rwd($RWD_TABLET_SMALL) {
      max-width: 475px;
      margin: 47px auto 35px auto;
    }
    @include rwd($RWD_TABLET) {
      max-width: 630px;
      margin: 50px auto 60px auto;
    }
    @include rwd($RWD_DESKTOP) {
      max-width: 770px;
      margin: 60px auto;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
    }

    &-text {
      font-size: 0.9375em;
      font-weight: 600;
      line-height: 2em;
      letter-spacing: 0.1em;
      @include rwd($RWD_TABLET_SMALL) {
        font-size: 1em;
        line-height: 1.875em;
      }
      @include rwd($RWD_TABLET) {
      }
      @include rwd($RWD_DESKTOP) {
        font-size: 1.125em;
        line-height: 1.667em;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
      }
    }
  }
}
</style>
